import { IntegrationItemKind } from "@/pages/integrations/integrations-page.types";
import { observer } from "mobx-react-lite";
import { IntegrationsFormattingForEmail } from "@/pages/integrations/shared/integrations-formatting-for-email";
import { IntegrationsFormattingForTextMessage } from "@/pages/integrations/shared/integrations-formatting-for-text-message";

type Props = {
  itemKind: IntegrationItemKind;
};

export const IntegrationsFormatting = observer(({ itemKind }: Props) => {
  if (itemKind === "email") {
    return <IntegrationsFormattingForEmail />;
  }

  if (itemKind === "text-message") {
    return <IntegrationsFormattingForTextMessage />;
  }

  return null;
});
